(function($) {

	'use strict';


	var init = function() {
        /** Hero Slider */
        var heroSwiper = new Swiper('.swiper-slider-container', {
            // Optional parameters
            slidesPerView: 1,
            spaceBetween: 30,
            effect: 'fade',
            loop: true,
            direction: 'horizontal',

            autoplay: {
                delay: 4000,
                disableOnInteraction: true,
            },

            on: {
                slideChangeTransitionEnd: function () {
                    cloneContent();
                    /** trigger popup */
                    $(".popUp__lightbox").on("click", function() {
                      
                        $(".popUp__content__lightbox, .lightbox__content").addClass("active");
                        $("body").addClass("active-popup");
                        popup_swiper();
                    });
                },
            },
        
            // If we need pagination
            pagination: {
            el: '.swiper-hero-pagination',
            clickable: 'true',
            },
        })

        var logoSwiper = new Swiper('.swiper-logo-container', {
            // spaceBetween: 15,
            loop: true,
            direction: 'horizontal',
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.swiper-logo-button-next',
                prevEl: '.swiper-logo-button-prev',
            },
            slidesPerView: 1,
            breakpoints: {
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 3,
                },
                1200: {
                  slidesPerView: 4,
                },
            }
        })
        
        /** Making Slider */
        var makingSwiper = new Swiper('.swiper-making-container', {
            // Optional parameters
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 30,
            effect: 'fade',
            loop: true,
            direction: 'horizontal',
            allowTouchMove: false,
            hashnav: true,
            hashnavWatchState: true,
            hashNavigation: {
                watchState: true,
              },
              
            on: {
                slideChangeTransitionStart: function () {
                cloneMakingContent();
                },

                update: function() {
                    cloneMakingContent();
                }
            },

            navigation: {
                nextEl: '.swiper-popup-next',
                prevEl: '.swiper-popup-prev',
            },
            
        })
        /** Inner Slider */
        var innerSwiper = new Swiper('.swiper-inner-container', {
            // Optional parameters
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 30,
            effect: 'fade',
            loop: false,
            direction: 'horizontal',
            watchOverflow: true,
            autoplay: {
                delay: 3500,
                disableOnInteraction: true,
            },
        
            // If we need pagination
            pagination: {
            el: '.swiper-inner-pagination',
            clickable: true,
            },
        })

        var popup_swiper = function() {
            makingSwiper.update();
        }

        $(".popUp__lightbox__contact").on("click", function() {
            $(".popUp__content__lightbox__contact").addClass("active");
            $("body").addClass("active-popup");
            popup_swiper();
        });

        $(".popUp__lightbox").on("click", function() {
            $(".popUp__content__lightbox, .lightbox__content").addClass("active");
            $("body").addClass("active-popup");
        });

        /*$(".swiper-container").hover(function() {
            (this).swiper.autoplay.stop();
        }, function() {
            (this).swiper.autoplay.start();
        });*/

        $(".swiper-container").click(function() {
            (this).swiper.autoplay.stop();
        });

    };

    
    var cloneContent = function() {
        $('.swiper-slide-project').empty();
        var templateContent = $('.swiper-slide-active .swiper-slide-reference');
        var cloneContent = templateContent.clone();
        $('.swiper-slide-project').append(cloneContent.html());
    }

    var cloneMakingContent = function() {
        $('.swiper-making-project').empty();
        var templateContentMaking = $('.swiper-slide-active .lightbox__text');
        var cloneContentMaking = templateContentMaking.clone();
        $('.swiper-making-project').append(cloneContentMaking.html());
    }

    $(".lightbox__close").on("click", function() {
        $(".popUp__content__lightbox.active, .lightbox__content.active").removeClass("active");
        $(".popUp__content__lightbox__contact").removeClass("active");
        $("body").removeClass("active-popup");
    });

    
    $('video').parent().click(function () {
        if($(this).children("video").get(0).paused){
            $(this).children("video").get(0).play();
            $(this).children(".playpause").fadeOut();
        }else{
            $(this).children("video").get(0).pause();
            $(this).children(".playpause").fadeIn();
          }
    });

	$(document).ready(function() {
        init();
        cloneContent();
	});

})(jQuery);



